import { Navigate } from 'react-router-dom';
import { Role, useUserQuery } from './api/gql';
import { FullPageLoader } from './components';
import { AppLayout } from './layout';
import { AdminLayout } from './layout/app/AdminLayout';
import { notify } from './utils/notification';

export const ClientRootComponent = () => {
  const { data, isLoading } = useUserQuery(undefined, {
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (!data) {
    return <Navigate to={'/error'} />;
  }

  // todo: uncomment if user should be unable to access client site as admin
  // if (data.user.role === Role.Admin) {
  //   return <Navigate to={'/admin'} />;
  // }

  if (!data.user.phoneNumber) {
    return <Navigate to={'/user-registration'} />;
  }

  return <AppLayout />;
};

export const AdminRootComponent = () => {
  const { data, isLoading } = useUserQuery(undefined, {
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return <FullPageLoader />;
  }

  if (!data) {
    return <Navigate to={'/error'} />;
  }

  if (data.user.role === Role.User) {
    notify.negative({
      message: 'Chyba autorizace. Admin sekce Vám není přístupná.',
    });
    return <Navigate to={'/'} />;
  }

  return <AdminLayout />;
};
